import { isDesktopDevice } from "./base";

export const linkPropsByDevice = isDesktopDevice
  ? {
      target: "_blank",
      rel: "noopener noreferrer",
    }
  : {
      target: "_self",
      rel: "",
    };

export function redirectTo(url: string): void {
  window.open(url, linkPropsByDevice["target"]);
}
